import { regexForName } from "common/constant";
import { getOptionValue, utilityOptionsForUser } from "common/enums";
import { uniqueId } from "lodash";
import * as Yup from "yup";

export const AdminProfileValidationSchema = Yup.object({
  userName: Yup.string().required("User name is required"),
  firstName: Yup.string()
    .matches(regexForName, "Please enter a valid first name")
    .required("First name is required"),
  lastName: Yup.string().matches(
    regexForName,
    "Please enter a valid last name"
  ),
  email: Yup.string()
    .email("Please enter valid email")
    .required("Email is required"),
});

export const UserProfileValidationSchema = Yup.object({
  firstName: Yup.string()
    .matches(regexForName, "Please enter a valid first name")
    .required("First name is required"),
  lastName: Yup.string().matches(
    regexForName,
    "Please enter a valid last name"
  ),
  email: Yup.string()
    .email("Please enter valid email")
    .required("Email is required"),
  mobileNumber: Yup.string()
    .matches(/^\d{10}$/, "Please enter valid mobile number")
    .required("Mobile number is required"),
});

export const initialValuesForProfileDetails = (user) => {
  const { email, firstName, lastName, mobileNumber, profileImage, middleName,signatureImage } =
    user;
  return {
    firstName: firstName ?? "",
    lastName: lastName ?? "",
    email: email ?? "",
    mobileNumber: mobileNumber ?? "",
    file: "",
    profileImageURL: profileImage ?? "",
    signatureImage: signatureImage ?? "",
  };
};

export const initialValuesForAdminProfileDetails = (user, rolesOptions) => {
  const {
    id,
    firstName,
    lastName,
    userName,
    profileImage,
    email,
    utaCardIssuanceDepartmentRoles,
    signatureImage,
  } = user;
  return {
    id: id ?? 0,
    firstName: firstName ?? "",
    lastName: lastName ?? "",
    email: email ?? "",
    userName: userName ?? "",
    profileImageURL: profileImage ?? "",
    file: "",
    signatureImage: signatureImage ?? "",
    departmentRoles: utaCardIssuanceDepartmentRoles?.map(
      ({ departmentId, utaCardIssuanceRoles: currentRoles }) => {
        const roles = rolesOptions
          ? rolesOptions.map(({ name, id }) => ({ label: name, value: id }))
          : [];
        return {
          id: uniqueId(),
          departmentId,
          roles: roles.filter(({ value }) =>
            currentRoles.find(({ id }) => id === value)
          ),
        };
      }
    ) ?? [{ departmentId: "", roles: [], id: uniqueId() }],
  };
};
